import { makeStyles } from '@material-ui/styles'

export const mapVisitorWarningStyles = makeStyles((theme) => ({
  mapVisitorParent: {
    position: 'absolute',
    top: '55px',
    left: '85px',
    width: '300px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      left: '55px',
    },
  },
  mapVisitorRelativeContainer: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },
  mapVisitorWarningContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 10,
    background: '#494949',
    color: theme.color.white,
    fontWeight: 600,
    textAlign: 'left',
  },
  mapVisitorButton: {
    marginTop: 10,
    color: theme.color.rutgersRed,
    background: theme.color.white,
    border: `1px solid #cc0033`,
    '&:hover': {
      background: 'white',
      color: theme.color.rutgersRed,
    },
  },
  mapVisitorButtonIcon: {
    position: 'absolute',
    top: '-11%',
    left: '99%',
    background: '#7e7e7e',
    width: 20,
    height: 20,
    '&:hover': {
      background: '#7e7e7e',
    },
    [theme.breakpoints.down('sm')]: {
      left: '95%',
    },
  },
}))

export default mapVisitorWarningStyles
